import React from 'react';
import { StyleSheet, View } from 'react-native';
import Theme from '../../../../theme';
import { defaultScale } from '../../../../utils/scaling';
import { Button } from '../../../../components';
import { ButtonSize, ButtonTypes } from '../../../../components/Button';

const styles = StyleSheet.create({
  footerButtons: {
    bottom: 0,
    paddingHorizontal: defaultScale(16),
    width: '100%',
  },
  actionSheetContainer: {
    width: '100%',
    alignItems: 'center',
  },
  button: {
    marginTop: defaultScale(10),
    width: '100%',
  },
});

interface IProps {
  primaryButtonText: string;
  onPrimaryButtonPress: () => void;
  isLoading: boolean;
  secondaryButtonText?: string;
  onSecondaryButtonPress?: () => void;
}

function FooterButtons({
  primaryButtonText,
  onPrimaryButtonPress,
  isLoading,
  secondaryButtonText,
  onSecondaryButtonPress,
}: IProps) {
  return (
    <View style={styles.footerButtons}>
      <View style={styles.actionSheetContainer}>
        <Button
          fontColor={Theme.WHITE}
          size={ButtonSize.MEDIUM}
          containerStyle={styles.button}
          onPress={onPrimaryButtonPress}
          title={primaryButtonText}
          isLoading={isLoading}
        />
        {secondaryButtonText && onSecondaryButtonPress && (
          <Button
            fontColor={Theme.PRIMARY}
            buttonType={ButtonTypes.OUTLINE}
            size={ButtonSize.MEDIUM}
            containerStyle={styles.button}
            onPress={onSecondaryButtonPress}
            title={secondaryButtonText}
            disabled={isLoading}
          />
        )}
      </View>
    </View>
  );
}

export default FooterButtons;
